/**
 * @module domain
 * @category client
 */

/**
 * Extracts the main domain name from the current window location.
 * 
 * This function removes the first subdomain from the hostname to get the main domain.
 * For example, if hostname is "app.example.com", it returns "example.com".
 *
 * @memberof module:domain
 * @returns {string} The main domain name without the first subdomain.
 */
const domain = window.location.hostname.split('.')
domain.shift()

const DomainName = domain.join('.')

export default DomainName

/**
 * Extracts the domain name for subdomain operations from the current window location.
 * 
 * This function removes the first two subdomains from the hostname to get the domain for subdomain operations.
 * For example, if hostname is "app.sub.example.com", it returns "example.com".
 *
 * @memberof module:domain
 * @returns {string} The domain name for subdomain operations.
 */
const domainForSubdomain = window.location.hostname.split('.')
domainForSubdomain.shift()
domainForSubdomain.shift()

export const DomainForSubdomainName = domainForSubdomain.join('.')
